import type { ChatRequestPayload, Message } from "../types/app";

export function buildPromptPayload(args: {
  conversationId: string;
  characterName: string;
  systemPrompt: string;
  memories: string[];
  recentMessages: Pick<Message, "role" | "content">[];
  userMessage: string;
  maxResponseChars: number;
}): ChatRequestPayload {
  return {
    conversationId: args.conversationId,
    characterName: args.characterName,
    systemPrompt: args.systemPrompt,
    memories: args.memories,
    recentMessages: args.recentMessages.slice(-8),
    userMessage: args.userMessage.slice(0, 4000),
    maxResponseChars: Math.min(Math.max(args.maxResponseChars, 120), 1800),
  };
}
